import { render, staticRenderFns } from "./zsgl.vue?vue&type=template&id=60455410&scoped=true"
import script from "./zsgl.vue?vue&type=script&lang=js"
export * from "./zsgl.vue?vue&type=script&lang=js"
import style0 from "../../views/ksgl-page/assets/css/rem.css?vue&type=style&index=0&id=60455410&prod&scoped=true&lang=css&external"
import style1 from "./zsgl.vue?vue&type=style&index=1&id=60455410&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60455410",
  null
  
)

export default component.exports